import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, FlatList, ScrollView,
	Platform, Dimensions, Linking, AsyncStorage, I18nManager } from "react-native";
	
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import Main from "../widgets/Main";
import GoogleMapComponentWithMarker from "../widgets/Maps";
import MainComponent from "../utilities/MainComponent";
import i18n from 'i18n-js';
import moment from 'moment';
import firebase from "../config/firebase.json"


export default class BranchDetailsScreen extends MainComponent {	

	static path = ''

	state = {
		store: {},
		timings: [],
		isBranchOpen : false,
		title: "Branches",
		showFullMode 	: true,
		data : [],
		item : {title : ""}
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);
		
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		this.state.height = screenHeight
		this.state.width = screenWidth

		if(this.props.navigation.state === undefined || this.props.navigation.state.params === undefined || this.props.navigation.state.params.branch === undefined || this.props.navigation.state.params.branch ===''){
			this.props.navigation.navigate("branches");
			return
		}

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
	}

	getDetails = async () => {		
		await Font.loadAsync(color.appFonts);
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)	

			var branch = undefined
			value.branches.forEach((value, index) => {
				if(index == this.props.navigation.state.params.branch)
					branch = value
			});

			if(branch == undefined)
			{
				this.props.navigation.navigate("branches");
			}
			else
			{
				this.state.storeCoords = branch.coords			
				this.setState({store: value, item: branch, storeCoords: branch.coords})
			}

        } catch (error) {
            console.log(error)
		}
		
		var timings = []
		var timingsList = this.state.item.timings
		
		if(timingsList != undefined)
		{
			let weekdayIndex = moment(new Date()).day();

			this.state.item.timings.map(obj => 
			{
				let timing = obj.openingTime + " - " + obj.closingTime
				var mOpen = false;
				if (obj.day == weekdayIndex || obj.day == -1) 
				{
					mOpen = this.parseTimings(
						obj.openingTime == undefined ? "" : obj.openingTime, 
						obj.closingTime == undefined ? "" : obj.closingTime)					
				}

				
				timings.push({isOpen: mOpen, timing: timing, day: this.getDayName(obj.day), closingTime: obj.closingTime})
			});
		}

		timings.sort((a,b) => a.isOpen - b.isOpen);
		timings.reverse()
		this.state.timings = timings
		this.state.isBranchOpen = this.isBranchOpen()
		this.setState({timings: this.state.timings, isBranchOpen: this.state.isBranchOpen})
	}

	isBranchOpen()
	{
		let timings = this.state.item.timings 
		if(timings == undefined)
			return false

		if (timings.length > 0) 
		{           
			let weekdayIndex = moment(new Date()).day();
			var isOpen = false
			var dayFound = false
			timings.forEach((workingDay, index) => {
				if (workingDay.day == weekdayIndex || workingDay.day == -1) {
					dayFound = true
					let mOpen = this.parseTimings(
										workingDay.openingTime == undefined ? "" : workingDay.openingTime, 
										workingDay.closingTime == undefined ? "" : workingDay.closingTime)
					if (mOpen == true){
						isOpen = true
					}
				}
			});	
			 
			if (dayFound){
			 	return isOpen
			}else{
				 return false
			}
		}else{
			return false
		}
	}

	parseTimings(openingTimings, closingTimings)
	{
        if (openingTimings == ""){
            return false
        }
        if (openingTimings == ""){
            return false
        }

		let timeOpening = openingTimings.toLowerCase().split(":")
        let timeClosing = closingTimings.toLowerCase().split(":")

		if (timeOpening.length == 2 && timeClosing.length == 2)
        {
            var minText = timeOpening[1].replace("am", "")
            minText = minText.replace("pm", "")
			minText = minText.replace(" " , "")

            var hour = +(timeOpening[0])
            let min  = +(minText)

            if (timeOpening[1].includes("am") && hour == 12){
                hour = 0
            }
            else if (timeOpening[1].includes("pm") && hour != 12){
                hour = hour + 12;
            }
            
			let openTime = hour * 60 + min
			

            var minTextClosing = timeClosing[1].replace("am", "")
            minTextClosing = minTextClosing.replace("pm", "")
            minTextClosing = minTextClosing.replace(" ", "")
            
            var hourClosing = +(timeClosing[0])
            let minClosing  = +(minTextClosing)
            
            if (timeClosing[1].includes("am") && hourClosing == 12){
                hourClosing = 0
            }
            else if (timeClosing[1].includes("pm") && hourClosing != 12){
                hourClosing = hourClosing + 12;
            }
            
            var closeTime = hourClosing * 60 + minClosing
            if ( (closeTime - openTime) < 0){
                closeTime = closeTime + (24 * 60)
            }
			
            if (closeTime == openTime){
                return true
            }
            // Need to check if closing is greater than opening.
            
            let mCurrentTime =  moment(new Date()).format('hh:mm a').toLowerCase()
            let currentTime  = mCurrentTime.split(":")

            var currentText = currentTime[1].replace("am", "")
            currentText = currentText.replace("pm", "")
            currentText = currentText.replace(" ", "")
            
            var hourCurrent = +(currentTime[0])
            let minCurrent  = +(currentText)
            if (currentTime[1].includes("am") && hourCurrent == 12){
                hourCurrent = 0
            }
            else if (currentTime[1].includes("pm") && hourCurrent != 12){
                hourCurrent = hourCurrent + 12
            }

            var currentTimeVal = hourCurrent * 60 + minCurrent
            if ( (currentTimeVal - openTime) < 0){
                currentTimeVal = currentTimeVal + (24 * 60)
            }

            if (currentTimeVal >= openTime && currentTimeVal <= closeTime){
                return true
            }
            else{
                return false
            }
        }
        else{
            return false
        }
    }

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	moveToOrder()
	{
		this.updatePickup()
	}
	
	updatePickup = async => {
		
		let deliveryData = {branch: this.state.item}
		this.setState({deliveryData: deliveryData});
		AsyncStorage.setItem(store.delivery, JSON.stringify(deliveryData)).then((value) => 
		{	
			this.props.navigation.navigate("menu");
		})
	};

	renderStoryItem = ({ item, index }) => {
		var that = this;
		var timing = item.timing
		timing = timing.toLowerCase().replace(/am/gi, i18n.t("am"))
		timing = timing.replace(/pm/gi, i18n.t("pm"))
		let day = i18n.t(item.day.toLowerCase())

		return (
			<View  style={{ height: 50, backgroundColor: 'white'}}>
				<View  style={{ flexDirection: "row", height: 48, alignContent: "center", alignItems:"center", paddingLeft: 15, paddingRight: 15, backgroundColor: 'white'}}>
					{ item.isOpen  && ( <Text style={{ fontFamily: 'main-bold'   , color: 'black', fontSize: 15 }}>{day}</Text> )}
					{ !item.isOpen && ( <Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 15 }}>{day}</Text> )}
					{ item.isOpen  && ( 
					<Text style={{marginLeft: "auto", marginTop:5, fontFamily: 'main-bold', color: 'black', fontSize: 12 }}> {timing} </Text>
					)}
					{ !item.isOpen  && ( 
					<Text style={{marginLeft: "auto", marginTop:5, fontFamily: 'main-regular', color: 'black', fontSize: 12 }}> {timing} </Text>
					)}
				</View>
			</View>

		)
	}

	getDayName(day)
	{
		if(day == -1){
			return "Everyday"
		}else if (day == 0){
			return ("Sunday")
		}else if (day == 1){
			return ("Monday")
		}else if (day == 2){
			return ("Tuesday")
		}else if (day == 3){
			return ("Wednesday")
		}else if (day == 4){
			return ("Thursday")
		}else if (day == 5){
			return ("Friday")
		}else if (day == 6){
			return ("Saturday")
		}
	}
	
	// List View 
	renderDetails(marginTop){
		
		var that = this
		
		var shouldDisable = true;
		var mColor = "red";
		var openStatus = i18n.t("closed")
		var opacity = 0.5;

		if(this.state.isBranchOpen){
			shouldDisable = false;
			opacity = 1

			var timing = this.state.timings[0].closingTime
			timing = timing.toLowerCase().replace(/am/gi, i18n.t("am"))
			timing = timing.replace(/pm/gi, i18n.t("pm"))
			openStatus = i18n.t("open") + " " + i18n.t("until") + " " + timing
			mColor = "green"
		}

		var mapsUrl = "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing&key=" + firebase.apiKey
		return (
			<View style={{flex:1, marginTop: marginTop, backgroundColor: color.bigSeparator}}>
				
				<ScrollView
						style={{marginTop: 50}}
						nestedScrollEnabled={false}
						showsHorizontalScrollIndicator={false}
						showsVerticalScrollIndicator={false}				
				>

					<div style={{width: '100%',  height: 200}}>
						
						<GoogleMapComponentWithMarker									
							draggable={true}
							latlng={this.state.storeCoords}
							googleMapURL={mapsUrl}
							loadingElement={<div style={{ height: `100%` }} />}
							containerElement={<div style={{ height: `100%` }} />}
							mapElement={<div style={{ height: `100%` }} />}
						/>

					</div>
																								
					<View style={{height: 65,backgroundColor:"white", flexDirection: "row", paddingLeft: 15, paddingRight: 15, justifyContent: "center", alignItems: "center", alignContent: "center"}}>
																						
						<TouchableOpacity style={{height: 35, width: "48%", borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
															onPress={() => { 
																var url = 'http://maps.google.com/maps?saddr='+ this.state.storeCoords.lat + ',' + this.state.storeCoords.lng;
																window.open(url, "_blank") 
															}}
									>
										<Text style={{ fontFamily: 'main-bold', color: "black", fontSize: 13, textAlign: "center"}}>{i18n.t("getDirection")}</Text>
						</TouchableOpacity>

						<View style={{width: "4%"}}/>
												
						<TouchableOpacity style={{height: 35, width: "48%", borderColor:"#E5E5E9", borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}
															onPress={() => { 
																const url = `tel:${this.state.item.phone}`;
																Linking.canOpenURL(url)
																	.then((supported) => {
																		if (supported) {
																			return Linking.openURL(url)
																				.catch(() => null);
																		}
																	});													
																}}
								>
									<Text style={{ fontFamily: 'main-bold', color: "black", fontSize: 13, textAlign: "center"}}>{i18n.t("callBranch")}</Text>
						</TouchableOpacity>

					</View>
					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

					{ this.state.timings != undefined && this.state.timings.length > 0 && (
						<View style={{flex: 1}}>
							<View  style={{ flexDirection: "row", height: 50, alignContent: "center", alignItems:"center", paddingLeft: 15, backgroundColor: 'white'}}>
								<Text style={{ fontFamily: 'main-regular', color: mColor, fontSize: 28 }}>•</Text>
								<Text style={{ fontFamily: 'main-regular', color: mColor, fontSize: 15 }}> {openStatus} </Text>
							</View>		

							<View style={{height: 8,backgroundColor:color.bigSeparator}}/>
							
							<FlatList
									extraData={this.state}
									data={this.state.timings}
									renderItem={this.renderStoryItem}
									keyExtractor={(item, index) => item + "_" + index}
								/>						
						</View>															
					)}
					<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

				</ScrollView>

				{ this.state.store.enablePickup && (
				<View style={{height: 64, backgroundColor:"white", justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity disabled={shouldDisable} style={{opacity: opacity, marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.moveToOrder() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:that.state.store.primaryColor}}>
								<Text style={{ fontFamily: 'main-bold',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontSize:14}}>{i18n.t("pickup")}</Text>
							</View>
						</TouchableOpacity>
				</View>															
			)}
			</View>															
		)
	}

	render() {

		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		var branchName = ""
		if(this.state.item != undefined)
		{
			branchName = this.state.item.name
			if(i18n.locale != this.state.store.defaultLanguage){
				branchName    = this.state.item.nameSecondary
			}		
		}
		var that = this
		return (
			<View style={styles.container}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails()}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{branchName}</Text>																						
								</View>	
								<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems:"center"}}
										onPress={() => { this.props.navigation.goBack(null) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>		
							</View>

						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails()}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{this.state.item.title}</Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems:"center"}}
									onPress={() => { this.props.navigation.goBack(null) }} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.bigSeparator
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});